import { render, staticRenderFns } from "./PsPatientsListSearchBar.vue?vue&type=template&id=7bb432c4&scoped=true&"
import script from "./PsPatientsListSearchBar.vue?vue&type=script&lang=js&"
export * from "./PsPatientsListSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsListSearchBar.vue?vue&type=style&index=0&id=7bb432c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb432c4",
  null
  
)

export default component.exports